'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ensureConnection = undefined;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _performConnect = require('./performConnect');

var _connectionStates = require('../constants/connectionStates');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ensureConnection = exports.ensureConnection = function ensureConnection(connection, lifecycleHooks) {
  switch (connection.state) {
    case _connectionStates.INITIALIZED:
    case _connectionStates.CLOSED:
    case _connectionStates.FAILED:
    case _connectionStates.SUSPENDED:
      {
        return (0, _performConnect.performConnect)(connection, lifecycleHooks);
      }

    case _connectionStates.CONNECTING:
    case _connectionStates.DISCONNECTED:
    case _connectionStates.CONNECTED:
      {
        return _q2.default.Promise.resolve();
      }

    case _connectionStates.CLOSING:
      {
        return _q2.default.Promise.reject(new Error('PubSub connection closing'));
      }

    default:
      {
        return _q2.default.Promise.reject(new Error('Unknown PubSub status'));
      }
  }
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/ably/api-wrappers/ensureConnection.js
// module id = 777
// module chunks = 2 3